import { apiCall, createQueryString } from "../imports"

const PREFIX = "shop/tags"

export default {

    findTags(filters) {
        return apiCall('get', `${PREFIX}${createQueryString(filters)}`)
    },
}